import React from 'react';

const SvgKg = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="KG_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="KG_svg__b" fill="#fff">
        <use xlinkHref="#KG_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#KG_svg__a" />
      <path fill="#F22A46" mask="url(#KG_svg__b)" d="M0 0h28v20H0z" />
      <circle fill="#FFF04D" mask="url(#KG_svg__b)" cx={14} cy={10} r={3.333} />
      <path
        d="M14 14.714l-1.632 2.435-.413-2.902-2.527 1.486.887-2.794-2.922.243 2.012-2.133L6.667 10l2.738-1.049-2.012-2.133 2.922.243-.887-2.794 2.527 1.486.413-2.902L14 5.286l1.632-2.435.413 2.902 2.527-1.486-.887 2.794 2.922-.243-2.012 2.133L21.333 10l-2.738 1.049 2.012 2.133-2.922-.243.887 2.794-2.527-1.486-.413 2.902L14 14.714zm0-.047a4.667 4.667 0 1 0 0-9.334 4.667 4.667 0 0 0 0 9.334z"
        fill="#FFF04D"
        mask="url(#KG_svg__b)"
      />
    </g>
  </svg>
);

export default SvgKg;
